import React from 'react'

import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import NFIcon from '@components/shared/NFIcon'

export interface FeatureItemProps {
  icon: string
  text: string
  description?: string
  iconFontSize?: string
  tag?: {
    text: string
    className: string
  }
}

const FeatureItem: React.FC<FeatureItemProps> = ({
  icon,
  text,
  iconFontSize,
  description,
  tag,
}) => {
  const { t } = useTranslation()
  return (
    <li className="flex flex-row items-start not-last:mb-5">
      <span className="w-[22px] mr-3.5 flex flex-col items-center">
        <NFIcon icon={icon} className={classNames(iconFontSize ?? 'text-[22px]')} />
      </span>
      <p className="flex flex-col items-start">
        <span className="font-medium leading-4 pt-[2px]">{t(text)}</span>
        {description && <span className="font-normal leading-4 pt-1">{t(description)}</span>}
        {tag && (
          <span
            className={classNames(
              'text-white mt-2 px-1.5 py-0.5 text-xs font-medium rounded leading-4',
              tag.className
            )}>
            {t(tag.text)}
          </span>
        )}
      </p>
    </li>
  )
}

export default FeatureItem
